export default {
	//登录信息
	get UserMessage() {
		return localStorage.getItem('userMessage') ? JSON.parse(localStorage.getItem('userMessage')) : "";
	},
	set UserMessage(value) {
		localStorage.setItem('userMessage', value ? JSON.stringify(value) : value);
	},
	//公司列表
	get companyList() {
		return localStorage.getItem('companyList') ? JSON.parse(localStorage.getItem('companyList')) : "";
	},
	set companyList(value) {
		localStorage.setItem('companyList', value ? JSON.stringify(value) : value);
	},
	//公司{id:value} 键值
	get companyObj() {
		return localStorage.getItem('companyObj') ? JSON.parse(localStorage.getItem('companyObj')) : "";
	},
	set companyObj(value) {
		localStorage.setItem('companyObj', value ? JSON.stringify(value) : value);
	},
	//tab标签
	editableTabs: [{
		title: '首页',
		name: 'home',
		closable: false //标签是否可关闭
	}],
	//tab标签当前页面
	editableTabsValue: "home",
	keepAliveArr:"",
	isAndroid: false, //true:安卓 false:h5/web
}
